import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import LoadingIndication from '../../common/loading-indicator';

import ReferenceBox from '../../common/reference-box';
import Button from '../../common/button/button';
import articleTagsService from '../../../services/article-tags/article-tags';
import formattersService from '../../../services/formatters';

import './recommendations-section.css';

export default class RecommendationsSection extends Component {
  render() {
    let extraJSX;

    const { recommendations } = this.props;
    
    if (!recommendations) {
      extraJSX = (
        <LoadingIndication />
      );
    }
    else {
      if (recommendations.length === 0) {
        extraJSX = (
          <div>
            <p>There are no recommendations</p>
          </div>
        );
      }
      else {
        extraJSX = (
          <div className='recommendations-container'>
            <div className='recommendations'>
              {
                recommendations.map((recommedation, i) => 
                  <div key={ `recommedation-${i}` } className='little-grow-animation'>
                    <RecommedationBox { ...recommedation } />
                  </div>
                )
              }
            </div>

            <Link to='/recommnedations' title='Recommnedations'>
              <Button 
                label='Explore More' 
                isDark={ this.props.className !== 'dark' } />
            </Link>     
          </div>                 
        );
      }
    }

    return (
      <section className={ `${ this.props.className } section-container recommendations-section-container` }>
        <h3 className='section-title'>
          Recommendations
        </h3>

        { extraJSX }
      </section>
    );
  }
}

function RecommedationBox(props) { 
  const { tags, url, } = props;

  const relevantTags = articleTagsService.getRelevantRecommendationsTags(tags);

  return (
    <div className='recommedation-box little-grow-animation'>
      <ReferenceBox 
        { ...props }
        postTime={ undefined }
        link={ url } 
        isExternalResource={ true }
        tags={ relevantTags } />
    </div>
  );
}